if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener, event) {
        const image = opener.closest('modal-opener')?.querySelector('img');
        const bounds = image?.getBoundingClientRect();
        const pointer = event && event.detail > 0 && bounds?.width && bounds?.height;
        this.zoomPoint = {
          x: pointer ? Math.max(0, Math.min(1, (event.clientX - bounds.left) / bounds.width)) : 0.5,
          y: pointer ? Math.max(0, Math.min(1, (event.clientY - bounds.top) / bounds.height)) : 0.5,
        };
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        const container = this.querySelector('[role="document"]');
        if (activeMedia.tagName === 'IMG') {
          const point = this.zoomPoint;
          const position = () => {
            if (!this.hasAttribute('open') || !activeMedia.classList.contains('active')) return;
            const frame = container.getBoundingClientRect();
            const image = activeMedia.getBoundingClientRect();
            const left = container.scrollLeft + image.left - frame.left - container.clientLeft;
            const top = container.scrollTop + image.top - frame.top - container.clientTop;
            container.scrollTo({
              left: Math.max(left, Math.min(left + Math.max(0, image.width - container.clientWidth), left + image.width * point.x - container.clientWidth / 2)),
              top: Math.max(top, Math.min(top + Math.max(0, image.height - container.clientHeight), top + image.height * point.y - container.clientHeight / 2)),
              behavior: 'instant',
            });
          };
          position();
          requestAnimationFrame(position);
          if (!activeMedia.complete) activeMedia.addEventListener('load', position, { once: true });
        } else {
          activeMedia.scrollIntoView();
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
